/*
 * @Description:
 * @Author: 景 彡
 * @Date: 2022-09-29 10:27:20
 * @LastEditors: 景 彡
 */
import Vue from 'vue';
import Router from 'vue-router';
import { RouterItem } from '@/utils/interfaces';
import { filterRoutesByRole } from './routeFilter';

import HomeLayout from '@/layouts/admin/HomeLayout.vue';
import { PortalLayout } from '@/layouts/portal';
import RouteView from '@/layouts/RouteView';

import dynamicRoutes from './routes';

Vue.use(Router);

/** 静态路由 */
export const staticRoutes: RouterItem[] = [
  { path: '/', component: () => import(/* webpackChunkName: "portal" */ '@/views/portal/index.vue') },
  { path: '/login', component: () => import(/* webpackChunkName: "common" */ '@/views/portal/index.vue') },
  {
    path: '/portal',
    component: PortalLayout,
    meta: { title: '', hidden: true },
    children: [],
  },
  {
    path: '/logout',
    component: HomeLayout,
    meta: { title: '', hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "common" */ '@/views/logout.vue'),
        name: 'Logout',
        meta: { title: '注销登录', icon: 'example', noCache: true, hidden: true },
      },
    ],
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  //   meta: { title: '关于', icon: 'example', noCache: true },
  // },
  // { path: "/register", component: () => import(/* webpackChunkName: "common" */ "@/pages/login/Register.vue") },
  { path: '/404', component: () => import(/* webpackChunkName: "common" */ '@/views/404.vue') },
  // { path: '*', redirect: '/404' },
];

const router = new Router({
  //mode: 'history', // require service support
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 };
  },
  routes: staticRoutes,
});

/**  DynamicRoutes -> filter by userRoles =  userDynamicRoutes */
const userDynamicRoutes: RouterItem[] = [];

export function updateRolesRoute(roels?: string[]): RouterItem[] {
  userDynamicRoutes.splice(0, userDynamicRoutes.length);
  // TODO: filter routes
  if (roels) {
    const filtedRoute = filterRoutesByRole(dynamicRoutes, roels!);
    userDynamicRoutes.push(...filtedRoute);
  }
  console.log('user-dynamicRoutes', userDynamicRoutes);
  userDynamicRoutes.push({ path: '*', redirect: '/404' });
  return userDynamicRoutes;
}

export function getMenuRoutes() {
  return userDynamicRoutes.concat(...staticRoutes);
}

export { userDynamicRoutes };
export default router;
